import ReactSelect, { components } from 'react-select';
import { Image } from '@/shared/ui/image';

import { WRAPPER } from '@/shared/styles/themes';
import styled from 'styled-components';

export const ImageControl = styled(Image)`
  object-fit: cover;
  width: 20px;
  height: 20px;
`;

export const OptionWrapper = styled.div`
  display: flex;
  padding: 8px 12px 8px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  margin-bottom: 2px;
  position: relative;
  color: #afafaf;
  cursor: pointer;
  text-overflow: ellipsis;
  /* font-family: Onest; */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 16.8px */
  background: transparent;

  ${({ $isSelected }) =>
    $isSelected &&
    `
      border-radius: 5px;
      background: #27262B;
      color: #fff;      
    `}

  &:hover {
    border-radius: 5px;
    background: #625a63;
    color: #edeff5;
  }
`;

export const ValueWrapper = styled.div`
  display: flex;
  height: 20px;
  padding: 0;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  position: relative;
  color: #fff;
  cursor: pointer;
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 16.8px */
  ${({ $isSelected }) =>
    $isSelected &&
    `
      border-radius: 5px;
      background: #27262B;
      color: #fff;
    `}
`;

export const OptionCheck = styled.div`
  position: absolute;
  right: 12px;
`;

export const Wrapper = styled.div`
  ${WRAPPER};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  position: relative;
  padding: 0;

  @media (max-width: 768px) {
    margin: 0;
  }

  ${({ $alignToLeft }) =>
    $alignToLeft &&
    `
      // .language-select__value-container {
      //   display: none;
      // }
      // .language-select__indicators {
      //   margin-left: -8px;
      // }
    `}

  ${({ $alignToLeft, $isValueMode }) => {
    if ($isValueMode && !$alignToLeft) {
      return `
        @media (max-width: 768px) {
          margin: 0;
        }`;
    }
    return '';
  }}
`;

export const Select = styled(ReactSelect)`
  width: 100%;
  .language-select__menu {
    border-radius: 8px;
    margin-top: 4px;
    min-width: 180px;
    overflow: hidden;
    background: #3d3c41;
    z-index: 12;
  }

  .language-select__menu-list {
    padding: 6px;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
  }

  .language-select__value-container {
    display: flex;
    justify-content: center;
  }
  .language-select__control {
    min-width: 88px;
    gap: 6px;
    border-radius: 8px;
    cursor: pointer;
    padding: 12px;
    color: #edeff5;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    background: #4b444c;

    @media (max-width: 768px) {
      padding: 6px 12px;
    }
    @media (orientation: landscape) {
      padding: 10px;
    }

    ${({ $isFocused }) =>
      $isFocused &&
      `
        background: #27262B;    
        box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
      `}
  }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 9999;

  background: rgba(19, 19, 21, 0.65);
  backdrop-filter: blur(8px);
`;

export const ModalContent = styled.div`
  background: transparent;
  width: 100%;
  padding: 18px;
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;
